import React, { FC } from "react";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { ContentAlign, Size } from "@app/components/base-page/enums";
import { Button, RichText } from "@app/components/base-page/models";
import { LinkButtonAdapter } from "@app/components/base-page/components/link-button-adapter/LinkButtonAdapter";

type Props = {
  title: RichText;
  text: RichText;
  imageSide: ContentAlign;
  contentAlignment: ContentAlign;
  button?: Button[];
  mobileGapSize?: Size;
  isReverseOrder?: boolean;
};

export const ContentBlock: FC<Props> = ({
  title,
  text,
  imageSide,
  contentAlignment,
  button,
  mobileGapSize,
  isReverseOrder,
}) => (
  <div
    className={classNames(
      "lg:grow lg:basis-1/2",
      "xxl:px-20",
      { "lg:order-first": imageSide === ContentAlign.RIGHT },
      { "text-center lg:text-left": isReverseOrder },
      { "lg:text-center": contentAlignment === ContentAlign.CENTER },
      { "lg:text-left": contentAlignment === ContentAlign.LEFT },
      { "lg:text-right": contentAlignment === ContentAlign.RIGHT },
    )}
  >
    <div
      className={classNames(
        "text-primary-content",
        isReverseOrder ? "text-large md:text-medium" : "text-medium",
        "lg:text-large",
        "xl:text-xx-large",
        mobileGapSize === Size.LARGE && (text || button?.length)
          ? "mb-5"
          : "mb-2.5 lg:mb-5",
      )}
    >
      <BlockHeader richText={title} />
    </div>
    {text ? (
      <div
        className={classNames(
          "list-image-checkmark text-regular text-base-400",
          "[&>p]:mb-2.5",
          "[&_ul]:mt-5 [&_ul]:pl-6 [&_ul>li]:pl-3",
          "[&_ul]:list-disc [&_ul]:text-start",
          "[&_ul]:space-y-2.5",
          "[&_li]:break-inside-avoid",
          "[&_ul]:md:gap-x-10",
          "[&_ul]:md:gap-x-15",
          "[&_ul]:xl:columns-2",
          "[&_ul]:lg:mt-15 [&>p]:lg:mb-5",
          {
            "mb-5 lg:mb-8": button?.length,
          },
        )}
      >
        <BlockBody richText={text} />
      </div>
    ) : null}
    {button?.length ? <LinkButtonAdapter data={button[0]} /> : null}
  </div>
);
